import { MapPinOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import type { FilterDistance } from 'src/models/candidatesList';
import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

const TrlKeys = {
    rangeLess: 'resume.distance.less',
    500: 'distance.FIVE_HUNDRED_METRES',
    1000: 'distance.ONE_THOUSAND_METRES',
    3000: 'distance.THREE_THOUSAND_METRES',
    5000: 'distance.FIVE_THOUSAND_METRES',
    10000: 'distance.TEN_THOUSAND_METRES',
    15000: 'distance.FIFTEEN_THOUSAND_METRES',
};

interface Props {
    range: FilterDistance;
}

const Range: TranslatedComponent<Props> = ({ range, trls }) => {
    return (
        <span>
            <MapPinOutlinedSize16 />
            {NON_BREAKING_SPACE}
            {trls[TrlKeys.rangeLess]}
            {NON_BREAKING_SPACE}
            {trls[TrlKeys[range]]}
        </span>
    );
};

export default translation(Range);
